import { createSelector } from 'reselect';
import get from 'lodash/fp/get';
import getMatch from 'selectors/getMatch';
import {
  TERM_ARCHIVE,
  CATEGORY_ARCHIVE,
} from 'config/types/path';
import getArchivedPagination from './getArchivedPagination';

const defaultItemsPerPage = 9;
const itemsPerPageOverrides = {
  [CATEGORY_ARCHIVE]: 14,
  [TERM_ARCHIVE]: 14,
};

const getActivePagination = createSelector(
  [
    getMatch,
    get('active.pagination'),
    getArchivedPagination,
  ],
  ({ pathType }, pagination, archivedPagination) => {
    const perPage = itemsPerPageOverrides[pathType] || defaultItemsPerPage;
    return {
      ...archivedPagination,
      ...pagination,
      perPage,
    };
  },
);

export default getActivePagination;
